import React, {useEffect} from 'react';
import moment from 'moment';
import PopupCalendar from '../../../calendar/components/popup-calendar';
import styles from './edit-cell.module.scss';

type Moment = moment.Moment;

interface Props {
    value: string;
    onChange: (value: string) => void;
    active: boolean;
    displayValue?: React.ReactElement;
    minDate?: Moment;
    maxDate?: Moment;
}

const DateEditCell = (props: Props ) => {
    const { onChange, active } = props;
    const [value, setValue] = React.useState<Moment>(moment(props.value));
    const [open, setOpen] = React.useState(false);
    const today = moment().startOf('day');

    const handleChange = (value: Moment) => {
        setValue(value);
        const formatValue = value?.format('yyyy-MM-DD');
        onChange(formatValue ?? '');
        setOpen(false);
    }

    useEffect(() => {
        setOpen(active)
    }, [active]);

    return (<PopupCalendar
        view={'month'}
        value={value}
        state={{ open, setOpen }}
        onCalendarDateClick={handleChange}
        placement={'bottom-start'}
        renderer={props.displayValue ?? <div className={styles.date}>{value.format('L')}</div>}
        minDate={props.minDate ?? (today.clone()).add(-365, 'days')}
        maxDate={props.maxDate ?? today}/>)
}

export default DateEditCell;
